import { delete_, get, post, put } from ".";

export const createProject = (data) => {
  return post(`/api/admin/project/store`, true, data);
};
export const getAllProject = () => {
  return get(`/api/admin/project/list`, true);
};
export const progressProject = (id, progress) => {
  return put(`/api/admin/project/setProgress/${id}?progress=${progress}`, true);
};
export const updateProject = (projectId,data) => {
  return put(`/api/admin/project/update/${projectId}`, true, data);
};
export const deleteProject = (id) => {
  return delete_(`/api/admin/project/remove/${id}`, true);
};
